import b from 'b_';
import React from 'react';
import './ConnectionBlock.css';

const block = b.lock('ConnectionBlock');

function ConnectionBlock(text) {
    return <div className={block()}>{text}</div>;
}

export function And() {
    return ConnectionBlock('AND');
}

export function Or() {
    return ConnectionBlock('OR');
}
